import { EBadgeFilterStatusEnum, ECredentialType, IFilter } from "../../../models"

export interface IUserFilter extends IFilter {
    LevelIdFilter: string
    Search: string
    ActiveUsers: boolean
    FilterByDirectReports: boolean
    FilterByPunchDefault: boolean
    OnlyAccountUsers: boolean
    Supervisors: IFilterEntry[]
    HierarchyJobs: IHierarchyJobFilterEntry[]
    AllowPunchFromPersonalDevice: boolean
    Exempt: boolean
    SelfServiceLoginEnabled: boolean
    // it's Findd Biometric Agreemnt accepted
    MobileAgreementAccepted: boolean
    // it's Account Agreement accepted
    AccountAgreementAccepted: boolean
    UserModified: boolean
    Agency: boolean
    RequirePhase: boolean
    PayGroupIds: string[]
    CustomField1?: string
    CustomField2?: string
    CustomField3?: string
    CustomField4?: string
}

export interface IHierarchyJobFilterEntry {
    HierarchyId: string
    HierarchyName: string
    JobId: string
    JobName: string
}

export interface IPeopleFilter {
    Id: string
    Name: string
    EmployeeStatusFilters: IEmployeeStatusFilter[]
    SupervisorIds: IFilterEntry[]
    RecruiterSupervisorIds: IFilterEntry[]
    ComplianceSupervisorIds: IFilterEntry[]
    AccountManagerSupervisorIds: IFilterEntry[]
    PayrollSupervisorIds: IFilterEntry[]
    ApplicationVerified: boolean
    BadgeIds: IFilterEntry[]
    OccupationIds: IFilterEntry[]
    SpecialtyIds: IFilterEntry[]
}

export interface ICredentialFilter {
    Id: string
    Name: string
    Expired: boolean
    ExpirationDate: string
    Verified: boolean
    Completed: boolean
    SupervisorIds: IFilterEntry[]
    RecruiterSupervisorIds: IFilterEntry[]
    ComplianceSupervisorIds: IFilterEntry[]
    ExpiresIn: number
    ShowExpiryByDate: boolean
    ExpiryControl: EExpiryControl
    EmployeeStatusFilters: IEmployeeStatusFilter[]
    CredentialTypes: ICredentialTypeEntry[]
}

export interface ICredentialTypeEntry {
    Type: ECredentialType
    SubTypeId: string
    LicenseGoverningDistrictIds: IFilterEntry[]
    SubType: IFilterEntry
}

export interface IEmployeeStatusFilter {
    Status: IFilterEntry
    SubStatus: IFilterEntry
}

export interface IFilterEntry {
    Id: string
    Name: string
    Status: EBadgeFilterStatusEnum
}

export enum EExpiryControl {
    Date = 1,
    Text = 2
}

export interface IResourcePlannerScheduleFilter extends IFilter {
    HideCoreStaff: boolean
    HideFloatStaff: boolean
    HidePerDiemStaff: boolean
    HideAgencyStaff: boolean
    ViewOnlyProductiveShifts: boolean
    ViewUnscheduledStaff: boolean
    ViewOnlyFilledShifts: boolean
    ViewOnlyUnfilledShifts: boolean
    BasePositionIds: string[]
    ClientIds: string[]
    JobIds: string[]
}
